import React, { useMemo } from 'react';

import { IDynamicDiplayView } from '@components/widgets/dynamic-display';
import DynamicWidget from '@components/widgets/dynamic-display/DynamicWidget';
import { EnhancedDisplayType } from '@components/widgets/dynamic-display/EnhancedDisplay';

import { AmendmentDetails } from '../types';

type Props = {
  data: AmendmentDetails;
};

const PolicyDetailsWidgetAtom: React.FC<Props> = ({ data }) => {
  const pd = data?.policyDetails;

  const view = useMemo<IDynamicDiplayView>(() => {
    return {
      name: 'Policy Details',
      title: 'Policy Details',
      sections: [
        {
          name: 'policyDetailsSection',
          title: 'Policy Details',
          showActionButtons: false,
          properties: {
            Currency: {
              multiline: false,
              value: pd?.currency?.title,
              name: 'Currency',
              title: 'Currency',
              required: true,
              disabled: true
            },
            PolicyEffectiveDate: {
              multiline: false,
              value: pd?.policyEffectiveDate,
              name: 'PolicyEffectiveDate',
              title: 'Policy Effective Date',
              type: EnhancedDisplayType.Date,
              required: true,
              disabled: true
            },
            PolicyExpiryDate: {
              multiline: false,
              value: pd?.policyExpiryDate,
              name: 'PolicyExpiryDate',
              title: 'Policy Expiry Date',
              type: EnhancedDisplayType.Date,
              required: true,
              disabled: true
            }
          }
        }
      ]
    };
  }, [pd]);

  return <DynamicWidget hasThreeFields view={view} />;
};

export { PolicyDetailsWidgetAtom };
